// @ts-expect-error untyped module
import { getPathFromSearchKey } from '../../utils/params';
// @ts-expect-error untyped module
import { getCatalogServiceTrackingName } from '../../utils/i18n';
// @ts-expect-error untyped module
import { isProd } from '../../utils/env';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { CAROUSEL_SERVICES_PROD, CAROUSEL_SERVICES_QA } from '../../constants/HomepageIconMap';
import * as FilterKey from '../../constants/search/FilterKey';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { getServices } from '../../slices/serviceCatalogSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ServiceCarouselItem = ({
  name,
  Icon,
  onClick,
  to
}) => /*#__PURE__*/_jsx(RouterLink, {
  onClick: onClick,
  to: to,
  use: "unstyled",
  children: /*#__PURE__*/_jsxs(Flex, {
    margin: "400",
    flexDirection: "column",
    alignItems: "center",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Icon, {
      size: "800"
    }), /*#__PURE__*/_jsx(Text, {
      whiteSpace: "nowrap",
      children: name
    })]
  })
});
export default function HomepageServicesCarousel({
  isMobile
}) {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const catalogServices = useSelector(getServices);
  const renderedServiceButtons = useMemo(() => {
    const serviceIconMap = isProd() ? CAROUSEL_SERVICES_PROD : CAROUSEL_SERVICES_QA;
    return serviceIconMap.map(serviceIconObject => {
      const catalogService = catalogServices.filter(catService => catService.id === serviceIconObject.id)[0];
      return catalogService ? /*#__PURE__*/_jsx(ServiceCarouselItem, {
        onClick: () => {
          trackInteraction('click homepage service carousel', {
            feature: FilterKey.SERVICE,
            item_type: getCatalogServiceTrackingName(catalogService.id, catalogServices)
          });
        },
        to: `/${getPathFromSearchKey(FilterKey.SERVICE, catalogService.id, catalogServices)}`,
        name: catalogService.name,
        Icon: serviceIconObject.icon
      }, `carousel-service-${serviceIconObject.id}`) : null;
    });
  }, [catalogServices, trackInteraction]);
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "services-carousel",
    paddingBlockEnd: "800",
    as: "div",
    children: [isMobile && /*#__PURE__*/_jsx(RouterLink, {
      onClick: () => {
        trackInteraction('click service see all');
      },
      to: "/all",
      paddingBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.storefront.header.browseAll"
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      justify: "between",
      marginBlockEnd: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h3",
        marginBlockEnd: "600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.servicesCarouselTitle"
        })
      }), !isMobile && /*#__PURE__*/_jsx(RouterLink, {
        onClick: () => {
          trackInteraction('click service see all');
        },
        to: "/all",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.seeAll"
        })
      })]
    }), /*#__PURE__*/_jsx(ScrollContainer, {
      children: /*#__PURE__*/_jsx(TFlex, {
        align: "stretch",
        direction: "row",
        children: renderedServiceButtons
      })
    })]
  });
}